/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export var ResourceType = {
    Network: 'NETWORK',
    Location: 'LOCATION',
    Player: 'PLAYER',
    Campaign: 'CAMPAIGN',
    Content: 'CONTENT',
    ContentBundle: 'CONTENT_BUNDLE',
    Organisation: 'ORGANISATION',
    User: 'USER',
    ApiDocs: 'API_DOCS',
    Tag: 'TAG',
    Role: 'ROLE',
    System: 'SYSTEM',
    AccessGrant: 'ACCESS_GRANT',
    Any: 'ANY'
};
export function ResourceTypeFromJSON(json) {
    return ResourceTypeFromJSONTyped(json, false);
}
export function ResourceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ResourceTypeToJSON(value) {
    return value;
}
